import { __rest } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
import { icons } from './icon-lookup';
const StyledIcon = styled.div `
	color: ${({ color }) => color};
	svg {
		fill: currentColor;
		width: ${({ size }) => size}px;
		height: ${({ size }) => size}px;
		display: block; // SVGs are inline elements so leave extra whitespace below themselves by default (for things like the tails of y and g)
	}
`;
const DEFAULT_SIZE = 24;
export const Icon = (_a) => {
    var { color = 'black', name, size = DEFAULT_SIZE } = _a, props = __rest(_a, ["color", "name", "size"]);
    const Component = icons[name];
    return (React.createElement(StyledIcon, Object.assign({ color: color, size: size }, props),
        React.createElement(Component, null)));
};
//# sourceMappingURL=Icon.js.map